import React from 'react';
import Table from 'components/Table';
import dayjs from 'dayjs';
import { t } from 'i18next';
import { Button } from 'reactstrap';
function List({ headers, data, buttons, viewSuggestion }) {
  return (
    <Table
      title={t('sidebar.other_maintenance')}
      subtitle={t('information_other_shipping_mode.shipping_mode')}
      headers={headers.map((e) => (
        <th scope='col' key={`thead-${Math.random()}`}>
          {t(e)}
        </th>
      ))}
      buttons={buttons}
      data={data}
      rows={data?.data?.map((e, index) => (
        <tr key={`table-row-${Math.random()}`}>
          <td>{index + 1}</td>
          <td>{e.name}</td>
          <td>
            <a href={`mailto: ${e.email}`}>{e.email}</a>
          </td>
          <td>{e.phone}</td>
          <td>{e.prefer_contact}</td>
          <td>{e.company}</td>
          {e.feedback?.length > 50 ? (
            <td>
              <Button size='sm' onClick={() => viewSuggestion(e)}>
                View
              </Button>
            </td>
          ) : (
            <td>{e.feedback}</td>
          )}

          <td>{dayjs(e.createdAt).format('DD/MM/YYYY HH:ss')}</td>
        </tr>
      ))}
    />
  );
}

export default List;
